import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from "react";
import { Box, HStack, Text, VStack, useTheme } from "native-base";
import { AlertLevel } from "@madmedical/medical";
import Icon from "../icons/Icon";
const Metrics = ({ displayValue, alertLevel, valueFontSize = "4xl", unitFontSize = "sm", }) => {
    const { colors } = useTheme();
    const iconNames = useMemo(() => ({
        [AlertLevel.Alert]: "bullhorn",
        [AlertLevel.Warning]: "warning",
        [AlertLevel.Ok]: "checkmark",
    }), []);
    const iconColors = useMemo(() => ({
        [AlertLevel.Alert]: colors.rose[500],
        [AlertLevel.Warning]: colors.yellow[600],
        [AlertLevel.Ok]: colors.green[500],
    }), [colors]);
    if (!(displayValue === null || displayValue === void 0 ? void 0 : displayValue.length)) {
        return null;
    }
    return (_jsx(HStack, Object.assign({ space: 1 }, { children: displayValue.map((item, index) => {
            const [value, unit] = item.split(" ");
            return (_jsxs(Box, Object.assign({ mr: 2, flexDirection: "row" }, { children: [value && (_jsx(Text, Object.assign({ fontSize: valueFontSize }, { children: Number(value)
                            ? Number(value).toLocaleString()
                            : value }))), _jsxs(VStack, Object.assign({ justifyContent: "flex-end", ml: 1, mb: 1.5 }, { children: [alertLevel ? (_jsx(Icon, { name: iconNames[alertLevel], size: 12, fill: iconColors[alertLevel] })) : null, unit && (_jsx(Text, Object.assign({ fontSize: unitFontSize, color: "gray.600" }, { children: unit })))] }))] }), `metrics-item-${index}`));
        }) })));
};
export default Metrics;
